export default __webpack_public_path__ + "static/media/Visa_logo.0f362160.png";